import nostraTokenListAtom from './nostraTokenListAtom';
import { Decimal } from '../../datastructures';
import { NostraToken } from '../../interfaces';
import { MultiCallContract } from '../../services';
import { MULTICALL_CONTRACT_ADDRESS } from '../../constants';
import { createAsyncAtom } from '../../lib/state';
import { RpcProvider } from 'starknet';
import rpcProviderAtom from '../rpcProviderAtom';

export type AssetMinDebtMap = { [nostraTokenAddress: string]: Decimal };

const RESPONSE_CHUNK_SIZE = 3;

const fetchData = async (nostraDebtTokens: NostraToken[], provider: RpcProvider) => {
  try {
    const calldata = nostraDebtTokens.map(debtToken => {
      return {
        contractAddress: debtToken.address,
        entrypoint: 'minDebt',
        calldata: [],
      };
    });

    const multiCallContract = new MultiCallContract(MULTICALL_CONTRACT_ADDRESS, provider);

    const result = await multiCallContract.aggregate(calldata);
    if (!result) {
      return null;
    }

    const assetMinDebtMap: AssetMinDebtMap = {};

    for (let i = 0; i < result.length; i += RESPONSE_CHUNK_SIZE) {
      const debtToken = nostraDebtTokens[i / RESPONSE_CHUNK_SIZE];

      // Index 1,2 is for minDebt
      const minDebt = new Decimal({ low: result[i + 1], high: result[i + 2] }, debtToken.tokenPrecision);

      assetMinDebtMap[debtToken.address] = minDebt;
    }

    return assetMinDebtMap;
  } catch (error) {
    console.error(`useAssetMinDebt - Failed to load nostra debt token min debt!`, error);
    return null;
  }
};

const assetMinDebtAtom = createAsyncAtom(async get => {
  const nostraTokenList = await get(nostraTokenListAtom);
  const provider = await get(rpcProviderAtom);

  return await fetchData(
    nostraTokenList.filter(nostraToken => nostraToken.variant === 'debt'),
    provider,
  );
});

export default assetMinDebtAtom;
